import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import AudioManager from "../../Shared/AudioManager";
import {Global} from "../../Shared/Global";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class Submit extends cc.Component {
    // @property(cc.EditBox)
    // editBox: cc.EditBox;
    @property(cc.Node)
    item: cc.Node = null;
    @property(cc.Node)
    content: cc.Node = null;
    private data: any;

    start() {

    }

    updataUI(pa) {
        this.data = pa;
        cc.log("====data:",this.data);
        this.node.active = true;
        let listTip = this.data.listTip;

        if  (Array.isArray(listTip) && listTip.length > 0){
            for (let i = 0;i < listTip.length;i++){
                let item = cc.instantiate(this.item);
                item.parent = this.content;
                let editBox = item.getChildByName("New EditBox").getComponent(cc.EditBox);
                editBox.string = "";
                editBox.placeholder = i18n.t('label_text.inPlease_enter_the') + listTip[i];
                item.getChildByName("labName").getComponent(cc.Label).string = listTip[i] + ":";
                item.active = true;
            }
        }


    }

    onBtnClick(event, param) {
        AudioManager.playSound("button");
        if (param === "close") {
            this.node.destroy();
        } else if (param === "ok") {
            let editDataArr = [];
            let listTip = this.data.listTip;
            let editData = ''
            if(Array.isArray(listTip) && listTip.length > 0){
                for (let i = 0;i < this.content.children.length;i++){
                    let editString = this.content.children[i].getChildByName("New EditBox").getComponent(cc.EditBox).string;
                    if (!editString) {
                        UIManager.showToastUI(i18n.t('datum_text.input_datum'),Global.ToastType.Warnning);
                        return;
                    }
                    editDataArr.push(editString);
                    if  (i < listTip.length - 1){
                        editData += listTip[i] + ":" + editString +",";
                    }else if(i === listTip.length - 1){
                        editData += listTip[i] + ":" + editString;
                    }
                }
                let data = {
                    "id": this.data.id,
                    "user_submit_data": editData
                }
                NetworkLogic.activityApplyContentActivity(data, function (rec) {
                    UIManager.showToastUI(i18n.t("datum_text.apply_succ"),Global.ToastType.OK)
                    cc.log("====返回内容活动 rec：", rec);
                }.bind(this), function (err) {
                    cc.log("====返回内容活动 错误：",err);
                }.bind(this))
                this.node.destroy();
            }
        }
    }
}
